module.exports = __webpack_public_path__ + "img/14.900544c2.png";